// extracted by mini-css-extract-plugin
module.exports = {"logo":"src-hellospa-components-global-header-global-header__logo--ZRmLq","upgradeCta":"src-hellospa-components-global-header-global-header__upgradeCta--3Cwwz"};